import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import { UpdateExpensesCheck } from '../../redux/actions/accountingExpenses'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import notification from '../../utils/notification'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import {
  sessionGetItemJSON,
  sessionGetItemObj,
  sessionRemoveItem,
} from '../../utils/sessionHelpers'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import ExpenseCheckView from './ExpenseCheckView'
import AccountingPeriodWidget from '../panelHeder/AccountingPeriodWidget'
import ExpenseCheckForm from './ExpenseCheckForm'
import pathname from '../../constants/pathname'

export default function ExpenseCheckWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()

  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')
  const { id, editMode } = sessionGetItemObj('checkData')

  let history = useHistory()

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError('')
    setIsShowConfirm(false)
    try {
      let response = await UpdateExpensesCheck(request, projectCode, periodInfo.periodNumber)
      if (response.model) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        doneLoading()
        history.push({
          pathname: `${pathname.incomeAndExpense.ExpenseCheckList}`,
        })
        //setFormSchema(response.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
        setIsError(DEFAULT_ERR_MSG)
      }
    } catch (e) {
      //console.log('error', e)

      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setRequest()
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    setRequest({
      id: id,
      checkClearingDateStr: data.checkClearingDate
        ? moment(data.checkClearingDate).format('YYYY/MM/DD')
        : null,
    })

    setIsShowConfirm(true)
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={<AccountingPeriodWidget periodInfo={periodInfo} />}
        bordered
      >
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {editMode && !formSchema?.disabled ? (
          <>
            <ExpenseCheckForm
              schema={formSchema?.form}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </>
        ) : (
          <>
            <ExpenseCheckView schema={formSchema?.form} />
          </>
        )}

        <div>
          <br />
          <Row>
            {isError && <Message showIcon type="error" description={isError} />}

            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {editMode && !formSchema?.disabled && (
                <>
                  <SaveButton onClick={handleSubmit(onSubmit)}>บันทึก</SaveButton>
                  <CancelButton
                    onClick={() => {
                      sessionRemoveItem('checkData')
                      // history.goBack()
                      history.push({
                        pathname: `${pathname.incomeAndExpense.ExpenseCheckList}`,
                      })
                    }}
                  >
                    ยกเลิก
                  </CancelButton>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Panel>

      <ConfirmWidget
        title={'ยืนยัน'}
        show={isShowConfirm}
        detail={'ยืนยันการบันทึก'}
        onCancle={() => {
          setIsShowConfirm(false)
        }}
        onConfirm={handleCallService}
      />

      {isLoading && <OverlayLoader />}
    </>
  )
}
